import { z } from 'zod';

export const apiKeySchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  keyPrefix: z.string(),
  scopes: z.array(z.string()),
  isActive: z.boolean(),
  expiresAt: z.string().nullable(),
  lastUsedAt: z.string().nullable(),
  createdBy: z.string(),
  createdAt: z.string(),
  revokedAt: z.string().nullable(),
  key: z.string().optional(),
});
export type ApiKeyEntity = z.infer<typeof apiKeySchema>;

export const apiKeyInputSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  scopes: z.array(z.string()).min(1, 'At least one scope is required'),
  expiresAt: z.string().optional(),
});
export type ApiKeyInput = z.infer<typeof apiKeyInputSchema>;
